import { useAppContainerStyle, useFirebaseAnalytics } from '@/shared/hooks'
import { useAppStore } from '@/shared/store'
import { useEffect, useState } from 'react'
import { refreshInterval } from '@/shared/constants'
import { getApiService } from '@/api/getApiService'
import { getUseFavoritesHook } from '@/shared/getContainer/getUseFavoritesHook'
import {
    getFromLocalStorage,
    sessionTokenLsKeyword,
} from '@/shared/localStorage/localStorageRepository'
import { getConfigHook } from '@/shared/getContainer/getConfigHook'
import { getGetFetchBootstrapsModule } from '@/shared/getContainer/getGetFetchBootstrapsModule'
import { init, setKeyMap } from '@noriginmedia/norigin-spatial-navigation'
import { refreshAccessToken } from '@/api/apiClient'

const fetchBootstraps = await getGetFetchBootstrapsModule()
const useFavoritesChannels = await getUseFavoritesHook()
const useConfig = await getConfigHook()

init({
    // debug: true, // Set this to false in production
    // visualDebug: false, // Shows the focusable components
    distanceCalculationMethod: 'center',
})

export const useAppTV = () => {
    const loginApi = getApiService()
    const appContainerStyle = useAppContainerStyle()
    const token: string | null = getFromLocalStorage(sessionTokenLsKeyword)
    const [isTokenInStorage, setIsTokenInStorage] = useState(!!token)
    const { isUserLoggedIn, actualProfile } = useAppStore()

    const { isSkinSet, takeConfigIfNeed } = useConfig()

    useEffect(() => {
        setKeyMap({
            left: [37],
            // eslint-disable-next-line id-length
            up: [38],
            right: [39],
            down: [40],
            enter: [13],
            // back: [8, 10009],
        })
        const interval = setInterval(async () => {
            await refreshAccessToken()
        }, refreshInterval)

        authenticateAndFetchConfig()
        getFavoritesChannels()

        // document.addEventListener('keydown', (event) => {
        //     // console.log(`Key pressed: ${event.keyCode}`)
        // })

        return () => clearInterval(interval)
    }, [])

    const authenticateAndFetchConfig = async () => {
        if (!isTokenInStorage) {
            const token = getFromLocalStorage(sessionTokenLsKeyword)
            if (token) {
                setIsTokenInStorage(true)
            }
        }

        if (isTokenInStorage) {
            await takeConfigIfNeed()
        }
    }

    const { analyticsLogEvent } = useFirebaseAnalytics()

    analyticsLogEvent('start_app')
    const analyticsMethods = {
        analyticsLogEvent,
    }

    const { getFavoritesChannels } = useFavoritesChannels()

    useEffect(() => {
        const interval = setInterval(async () => {
            loginApi.refreshAccessToken()
        }, refreshInterval)

        const handleAsyncFunctions = async () => {
            if (fetchBootstraps) {
                await fetchBootstraps()
            }
            await authenticateAndFetchConfig()
            await getFavoritesChannels()
        }

        handleAsyncFunctions()

        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        if (actualProfile?.id) {
            const handleAsyncFunctions = async () => {
                await getFavoritesChannels()
            }

            handleAsyncFunctions()
        }
    }, [actualProfile?.id])

    useEffect(() => {
        const handleAsyncFunctions = async () => {
            await authenticateAndFetchConfig()
        }

        handleAsyncFunctions()
    }, [token, isTokenInStorage])

    return {
        appContainerStyle,
        isUserLoggedIn: isSkinSet ? isUserLoggedIn : false,
        analyticsMethods,
        analyticsLogEvent,
    }
}
